import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	/**
	 * Specify your server-side environment variables schema here. This way you can ensure the app
	 * isn't built with invalid env vars.
	 */
	server: {
		COMMUNICATION_CONNECTION_STRING: z.string(),
		DATABASE_URL: z
			.string()
			.url()
			.refine(
				(str) => !str.includes("your DB url here"),
				"You forgot to change the default URL",
			),
		NODE_ENV: z
			.enum(["development", "test", "production"])
			.default("development"),
		TRANSLATION_ENDPOINT: z.string(),
		TRANSLATION_API_KEY: z.string(),
		TRANSLATION_REGION: z.string(),
		SPEECH_KEY: z.string(),
		SPEECH_REGION: z.string(),
		MSFT_AD_CLIENT_SECRET: z.string(),
		MSFT_TEAMS_BOT_EMAIL: z.string(),
		MSFT_TEAMS_BOT_ID: z.string(),
		BETTER_AUTH_SECRET: z.string(),
	},

	/**
	 * Specify your client-side environment variables schema here. This way you can ensure the app
	 * isn't built with invalid env vars. To expose them to the client, prefix them with
	 * `NEXT_PUBLIC_`.
	 */
	client: {
		NEXT_PUBLIC_APP_URL: z.string(),
		NEXT_PUBLIC_INSIGHTS_CONNECTION_STRING: z.string(),
		NEXT_PUBLIC_VERSION: z.string(),
		NEXT_PUBLIC_SOCKET_SERVER_HOSTNAME: z.string(),
		NEXT_PUBLIC_MSFT_AD_AUTHORITY: z.string(),
		NEXT_PUBLIC_MSFT_AD_CLIENT_ID: z.string(),
		NEXT_PUBLIC_MSFT_AD_TENANT_ID: z.string(),
		NEXT_PUBLIC_MSFT_AD_REDIRECT_URI: z.string(),
		NEXT_PUBLIC_LOW_ACCURACY_THRESHOLD: z.string(),
	},

	/**
	 * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
	 * middlewares) or client-side so we need to destruct manually.
	 */
	runtimeEnv: {
		COMMUNICATION_CONNECTION_STRING:
			process.env.COMMUNICATION_CONNECTION_STRING,
		DATABASE_URL: process.env.DATABASE_URL,
		NODE_ENV: process.env.NODE_ENV,
		NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
		NEXT_PUBLIC_INSIGHTS_CONNECTION_STRING:
			process.env.NEXT_PUBLIC_INSIGHTS_CONNECTION_STRING,
		TRANSLATION_ENDPOINT: process.env.TRANSLATION_ENDPOINT,
		TRANSLATION_API_KEY: process.env.TRANSLATION_API_KEY,
		TRANSLATION_REGION: process.env.TRANSLATION_REGION,
		NEXT_PUBLIC_VERSION: process.env.NEXT_PUBLIC_VERSION,
		SPEECH_KEY: process.env.SPEECH_KEY,
		SPEECH_REGION: process.env.SPEECH_REGION,
		NEXT_PUBLIC_SOCKET_SERVER_HOSTNAME:
			process.env.NEXT_PUBLIC_SOCKET_SERVER_HOSTNAME,
		MSFT_TEAMS_BOT_EMAIL: process.env.MSFT_TEAMS_BOT_EMAIL,
		MSFT_TEAMS_BOT_ID: process.env.MSFT_TEAMS_BOT_ID,

		NEXT_PUBLIC_MSFT_AD_AUTHORITY: process.env.NEXT_PUBLIC_MSFT_AD_AUTHORITY,
		NEXT_PUBLIC_MSFT_AD_CLIENT_ID: process.env.NEXT_PUBLIC_MSFT_AD_CLIENT_ID,
		NEXT_PUBLIC_MSFT_AD_TENANT_ID: process.env.NEXT_PUBLIC_MSFT_AD_TENANT_ID,
		NEXT_PUBLIC_MSFT_AD_REDIRECT_URI:
			process.env.NEXT_PUBLIC_MSFT_AD_REDIRECT_URI,
		BETTER_AUTH_SECRET: process.env.BETTER_AUTH_SECRET,
		MSFT_AD_CLIENT_SECRET: process.env.MSFT_AD_CLIENT_SECRET,
		NEXT_PUBLIC_LOW_ACCURACY_THRESHOLD:
			process.env.NEXT_PUBLIC_LOW_ACCURACY_THRESHOLD,
	},
	/**
	 * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
	 * useful for Docker builds.
	 */
	skipValidation: !!process.env.SKIP_ENV_VALIDATION,
	/**
	 * Makes it so that empty strings are treated as undefined.
	 * `SOME_VAR: z.string()` and `SOME_VAR=''` will throw an error.
	 */
	emptyStringAsUndefined: true,
});
